var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
export default (function (props) {
    switch (props.level) {
        case 1:
            return _jsx(StyledH1, { children: props.children });
        case 2:
            return _jsx(StyledH2, { children: props.children });
        case 3:
            return _jsx(StyledH3, { children: props.children });
        case 4:
        default:
            return _jsx(StyledH4, { children: props.children });
    }
});
var StyledH1 = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.spacing * 4; });
var StyledH2 = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.spacing * 3; });
var StyledH3 = styled.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.spacing * 2; });
var StyledH4 = styled.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.spacing * 1; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map